import { render, staticRenderFns } from "./pick-footer.vue?vue&type=template&id=27eab00d&scoped=true"
import script from "./pick-footer.vue?vue&type=script&lang=ts"
export * from "./pick-footer.vue?vue&type=script&lang=ts"
import style0 from "./pick-footer.vue?vue&type=style&index=0&id=27eab00d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eab00d",
  null
  
)

export default component.exports